import React, { useRef } from 'react';
import { useClickAway } from 'react-use';
import { Overlay, StyledContainer, StyledDialogContent } from './BottomDialog.styles';
import { useBottomDialogDispatch, useBottomDialogState } from './BottomDialogContext';
import { BottomDialogHeader } from './BottomDialogHeader';
import { RemixFocusLock } from '../ClientOnly/ClientOnly';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BottomDialog = () => {
  const {
    dialog
  } = useBottomDialogState();
  const dispatch = useBottomDialogDispatch();
  const modalRef = useRef(null);
  const onClose = () => {
    dispatch({
      type: 'remove-dialog'
    });
  };
  useClickAway(modalRef, onClose);
  return dialog && /*#__PURE__*/_jsx(RemixFocusLock, {
    children: /*#__PURE__*/_jsx(Overlay, {
      children: /*#__PURE__*/_jsxs(StyledDialogContent, {
        ref: modalRef,
        onKeyUp: event => {
          if (event.key === 'Escape') {
            onClose();
          }
        },
        children: [/*#__PURE__*/_jsx(BottomDialogHeader, {}), /*#__PURE__*/_jsx(StyledContainer, {
          children: dialog
        })]
      })
    })
  });
};